import { toast } from "react-toastify";

//toast notification for errors
export const notifyError = () => {
  toast.error("Something Went Wrong !", {
    position: toast.POSITION.TOP_CENTER,
  });
};

//toast notification for server errors
export const notifyServerError = () => {
  toast.error("Server Error !", {
    position: toast.POSITION.TOP_CENTER,
  });
};

//toast notification for status update errors
export const notifyStatusUpdateError = () => {
  toast.info("Order Status Updated By Partner Side !", {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 11000,
    closeButton: true,
  });
};

//toast notification for successful provisioning
export const notifySuccessfulProvison = () => {
  toast.success("Partner Store Provision Updated Successfully !", {
    position: toast.POSITION.TOP_CENTER,
  });
};

//toast notification for successful provisioning
export const notifyPendingIncomingOrders = () => {
  toast.info("There are pending incoming order, hurry make some action !", {
    position: toast.POSITION.TOP_CENTER,
    autoClose: false,
  });
};
